// import { create } from "zustand";
// import { apiCall } from "../../../../utils/apiCall";
// import { API_BASE_URL1, API_BASE_URL3 } from "../../../Services/baseApiUrl";

// // Utility function to serialize filter object into query string
// const serializeFilters = (filters) => {
//   return Object.entries(filters)
//     .map(([key, value]) => {
//       if (Array.isArray(value)) {
//         return value
//           .map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`)
//           .join("&");
//       }
//       return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
//     })
//     .join("&");
// };

// export const useVehicleStore = create((set, get) => ({
//   allVehicles: [],
//   vehicleDetails: [],
//   isSaveVehicleDetailsLoading: false,
//   isFetchVehicleDetailsLoading: false,
//   isFetchAllVehiclesLoading: false,
//   fetchVehicleDetailsError: null,
//   error: null,
//   success: null,
//   cache: {}, // Store cached responses with timestamps

//   // Cache duration (5 minutes in milliseconds)
//   CACHE_DURATION: 5 * 60 * 1000,

//   // Helper function to generate cache key
//   getCacheKey: (functionName, pageIndex, pageSize, filters) => {
//     const filterString = serializeFilters(filters);
//     return `${functionName}_${pageIndex}_${pageSize}_${filterString}`;
//   },

//   // Helper function to check if cache is valid
//   isCacheValid: (cacheEntry) => {
//     if (!cacheEntry) return false;
//     const { timestamp } = cacheEntry;
//     const now = Date.now();
//     return now - timestamp < get().CACHE_DURATION;
//   },

//   fetchAllVehicles: async (pageIndex = 1, pageSize = 10, filters = {}) => {
//     const cacheKey = get().getCacheKey("fetchAllVehicles", pageIndex, pageSize, filters);
//     const cachedData = get().cache[cacheKey];

//     // Return cached data if valid
//     if (cachedData && get().isCacheValid(cachedData)) {
//       set({
//         allVehicles: cachedData.data,
//         isFetchAllVehiclesLoading: false,
//         success: "Vehicles fetched from cache.",
//       });
//       return cachedData.data;
//     }

//     set({ isFetchAllVehiclesLoading: true });
//     try {
//       const filterString = serializeFilters(filters);
//       const allVehicles = await apiCall({
//         url: `${API_BASE_URL3}MasterDetails/GetAllVehicles?PageIndex=${pageIndex}&PageSize=${pageSize}&${filterString}`,
//         method: "get",
//         token: localStorage.getItem("token"),
//       });

//       // Update cache
//       set((state) => ({
//         cache: {
//           ...state.cache,
//           [cacheKey]: { data: allVehicles, timestamp: Date.now() },
//         },
//         allVehicles,
//         isFetchAllVehiclesLoading: false,
//         success: "Vehicles fetched successfully.",
//       }));
//       return allVehicles;
//     } catch (error) {
//       set({ error: error.message, isFetchAllVehiclesLoading: false });
//       throw error;
//     }
//   },

//   fetchVehicleDetails: async (pageIndex = 1, pageSize = 10, filters = {}) => {
//     const cacheKey = get().getCacheKey("fetchVehicleDetails", pageIndex, pageSize, filters);
//     const cachedData = get().cache[cacheKey];

//     // Return cached data if valid
//     if (cachedData && get().isCacheValid(cachedData)) {
//       set({
//         vehicleDetails: cachedData.data,
//         isFetchVehicleDetailsLoading: false,
//         success: "Vehicle details fetched from cache.",
//       });
//       return cachedData.data;
//     }

//     set({ isFetchVehicleDetailsLoading: true });
//     try {
//       const filterString = serializeFilters(filters);
//       const vehicleDetails = await apiCall({
//         url: `${API_BASE_URL3}MasterDetails/GetAllVehicles?PageIndex=${pageIndex}&PageSize=${pageSize}&${filterString}`,
//         method: "get",
//         token: localStorage.getItem("token"),
//       });

//       // Update cache
//       set((state) => ({
//         cache: {
//           ...state.cache,
//           [cacheKey]: { data: vehicleDetails, timestamp: Date.now() },
//         },
//         vehicleDetails,
//         isFetchVehicleDetailsLoading: false,
//         success: "Vehicles fetched successfully.",
//       }));
//       return vehicleDetails;
//     } catch (error) {
//       set({
//         fetchVehicleDetailsError: error.message,
//         isFetchVehicleDetailsLoading: false,
//       });
//       throw error;
//     }
//   },

//   saveVehicleDetails: async (vehicleData, isUpdate = false) => {
//     set({ isSaveVehicleDetailsLoading: true });
//     try {
//       const url = isUpdate
//         ? `${API_BASE_URL3}MasterCreate/UpdateVehicleDetails`
//         : `${API_BASE_URL3}MasterCreate/AddNewVehicle`;
//       const method = isUpdate ? "put" : "post";

//       const vehicleDetails = await apiCall({
//         url,
//         method,
//         data: vehicleData,
//         token: localStorage.getItem("token"),
//       });

//       set({
//         vehicleDetails,
//         isSaveVehicleDetailsLoading: false,
//         success: "Vehicle saved successfully.",
//       });
//       return { success: true, data: vehicleDetails };
//     } catch (error) {
//       set({ error: error.message, isSaveVehicleDetailsLoading: false });
//       throw error;
//     }
//   },
// }));



import { create } from "zustand";
import { apiCall } from "../../../../utils/apiCall";
import { API_BASE_URL1, API_BASE_URL3 } from "../../../Services/baseApiUrl";

// Utility function to serialize filter object into query string
const serializeFilters = (filters) => {
  return Object.entries(filters)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map((v) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`)
          .join("&");
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .join("&");
};

export const useVehicleStore = create((set) => ({
  allVehicles: [],
  vehicleDetails: [],
  isSaveVehicleDetailsLoading: false,
  isFetchVehicleDetailsLoading: false,
  isFetchAllVehiclesLoading: false,
  fetchVehicleDetailsError: null,
  error: null,
  success: null,

  // Updated fetchVehicleDetails to accept filter parameters
  fetchAllVehicles: async (pageIndex = 1, pageSize = 10, filters = {}) => {
    set({ isFetchAllVehiclesLoading: true });
    try {
      // Serialize filters
      const filterString = serializeFilters(filters);
      const allVehicles = await apiCall({
        url: `${API_BASE_URL3}MasterDetails/GetAllVehicles?PageIndex=${pageIndex}&PageSize=${pageSize}&${filterString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });
      set({
        allVehicles,
        isFetchAllVehiclesLoading: false,
        success: "Vehicles fetched successfully.",
      });
      return allVehicles;
    } catch (error) {
      set({ error: error.message, isFetchAllVehiclesLoading: false });
    }
  },
  // Updated fetchVehicleDetails to accept filter parameters
  fetchVehicleDetails: async (pageIndex = 1, pageSize = 10, filters = {}) => {
    set({ isFetchVehicleDetailsLoading: true });
    try {
      // Serialize filters
      const filterString = serializeFilters(filters);
      const vehicleDetails = await apiCall({
        url: `${API_BASE_URL3}MasterDetails/GetAllVehicles?PageIndex=${pageIndex}&PageSize=${pageSize}&${filterString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });
      set({
        vehicleDetails,
        isFetchVehicleDetailsLoading: false,
        success: "Vehicles fetched successfully.",
      });
    } catch (error) {
      set({
        fetchVehicleDetailsError: error.message,
        isFetchVehicleDetailsLoading: false,
      });
    }
  },

  saveVehicleDetails: async (vehicleData, isUpdate = false) => {
    set({ isSaveVehicleDetailsLoading: true });
    try {
      const url = isUpdate
        ? `${API_BASE_URL3}MasterCreate/UpdateVehicleDetails`
        : `${API_BASE_URL3}MasterCreate/AddNewVehicle`;
      const method = isUpdate ? "put" : "post";

      const vehicleDetails = await apiCall({
        url,
        method,
        data: vehicleData,
        token: localStorage.getItem("token"),
      });

      set({
        vehicleDetails,
        isSaveVehicleDetailsLoading: false,
        success: "Vehicle saved successfully.",
      });
      return { success: true, data: vehicleDetails };
    } catch (error) {
      set({ error: error.message, isSaveVehicleDetailsLoading: false });
      throw error;
    }
  },
}));
